import React from 'react';

const ResumeView = () => {
  return (
    <section className="resume-view">
      <div className="resume-toolbar">
        <span className="resume-path">~/resume.pdf</span>
        <a className="download-link" href="/resume.pdf" download>
          [ download ]
        </a>
      </div>
      <object
        data="/resume.pdf"
        type="application/pdf"
        className="resume-embed"
        aria-label="Akanksh Divyananda's resume"
      >
        <p className="resume-fallback">
          Your browser can't preview PDFs inline.{' '}
          <a href="/resume.pdf" download>
            Download the resume
          </a>{' '}
          instead.
        </p>
      </object>
    </section>
  );
};

export default ResumeView;
